// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__xvcPw","logo":"footer_logo__0KLOb","list":"footer_list__7+Vkf"};